/**
 * WebMCP bridge — exposes read-only storefront tools to in-browser AI agents.
 * Registers via document.modelContext.registerTool() on page load (W3C WebMCP spec).
 */
(function () {
  'use strict';

  var SITE = 'https://www.laurosport.store';
  var registered = false;
  var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;

  function getModelContext() {
    if (typeof document !== 'undefined' && document.modelContext) {
      return document.modelContext;
    }
    if (typeof navigator !== 'undefined' && navigator.modelContext) {
      return navigator.modelContext;
    }
    return null;
  }

  function buildTools() {
    return [
      {
        name: 'search_products',
        title: 'Search products',
        description: 'Search Lauro Sport products by keyword, brand, or category.',
        inputSchema: {
          type: 'object',
          properties: {
            q: { type: 'string', description: 'Search query' },
          },
          required: ['q'],
        },
        annotations: { readOnlyHint: true },
        execute: async function (input) {
          var res = await fetch(SITE + '/api/search?q=' + encodeURIComponent(input.q));
          return res.json();
        },
      },
      {
        name: 'get_catalog',
        title: 'Get product catalog',
        description: 'Fetch the Lauro Sport product catalog (paginated JSON).',
        inputSchema: {
          type: 'object',
          properties: {
            page: { type: 'integer', minimum: 1, description: 'Page number (optional)' },
          },
        },
        annotations: { readOnlyHint: true },
        execute: async function (input) {
          var url = SITE + '/api/catalog';
          if (input && input.page) url += '?page=' + input.page;
          var res = await fetch(url);
          return res.json();
        },
      },
      {
        name: 'get_store_docs',
        title: 'Get agent documentation',
        description: 'Fetch the Lauro Sport agent operating manual (agents.md).',
        inputSchema: {
          type: 'object',
          properties: {},
        },
        annotations: { readOnlyHint: true },
        execute: async function () {
          var res = await fetch(SITE + '/agents.md');
          return { content: await res.text() };
        },
      },
      {
        name: 'browse_collections',
        title: 'Browse collections',
        description: 'List product categories and collection URLs for navigation.',
        inputSchema: {
          type: 'object',
          properties: {},
        },
        annotations: { readOnlyHint: true },
        execute: async function () {
          var res = await fetch(SITE + '/sitemap-categories.xml');
          return { content: await res.text(), format: 'application/xml' };
        },
      },
    ];
  }

  function registerWebMcpTools() {
    if (registered) return true;

    var mc = getModelContext();
    if (!mc) return false;

    var tools = buildTools();
    var options = controller ? { signal: controller.signal } : {};

    if (typeof mc.registerTool === 'function') {
      var count = 0;
      for (var i = 0; i < tools.length; i++) {
        try {
          mc.registerTool(tools[i], options);
          count++;
        } catch (err) {
          if (err && err.name === 'InvalidStateError') {
            count++;
            continue;
          }
          throw err;
        }
      }
      registered = count === tools.length;
      return registered;
    }

    if (typeof mc.provideContext === 'function') {
      mc.provideContext({ tools: tools });
      registered = true;
      return true;
    }

    return false;
  }

  if (registerWebMcpTools()) return;

  if (typeof document !== 'undefined') {
    document.addEventListener('DOMContentLoaded', registerWebMcpTools);

    var attempts = 0;
    var poll = setInterval(function () {
      if (registerWebMcpTools() || ++attempts >= 50) {
        clearInterval(poll);
      }
    }, 100);
  }
})();
